// @ts-nocheck
import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { DatePickerComponent } from '../../../../fields/date-picker/date-picker.component';
import { GridboxUniqueComponent } from '../../../../fields/gridbox-unique/gridbox-unique.component';
import { InputTextComponent } from '../../../../fields/input-text/input-text.component';
import { SelectTreeComponent } from '../../../../fields/select-tree/select-tree.component';
import { MessageFeedbackService } from '../../../../message-feedback/message-feedback.service';

import {
  assocPath as assocPathRamda,
  equals as equalsRamda,
  mapObjIndexed as mapObjIndexedRamda,
  multiply as multiplyRamda,
  path as pathRamda,
  pipe as pipeRamda,
} from 'ramda';
import { MessageFeedbackComponent } from '../../../../message-feedback/message-feedback.component';
import { EntityFieldsComponent } from '../../sub-form/entity-fields/entity-fields.component';
import { initalFormControl, initalFormData } from '../constants';
import { LegalRequestService } from '../legal-request.service';

type FieldsFormData =
  | 'typeId'
  | 'typeExchangeRate'
  | 'dolarQuotation'
  | 'primaryValue'
  | 'primaryValueUS'
  | 'endValue'
  | 'primaryIndexId'
  | 'dateReference'
  | 'interestType'
  | 'interestDateReference'
  | 'interestPercents'
  | 'penaltyPercents'
  | 'emailList'
  | 'ipList'
  | 'urlList'
  | 'imeiList'
  | 'accountIdList'
  | 'hasInterest'
  | 'hasPenalty'
  | 'hasPrimary'
  | 'financialCode';

type FormDataItem = {
  value: string | null | boolean | number;
  error: any;
};

type FormDataItemDate = {
  value: string | number;
  error: any;
};

type FormDataLegalRequest = {
  [key in FieldsFormData]: FormDataItem | { [key: string]: FormDataItem };
} & {
  interestDateReference: FormDataItemDate;
  dateReference: FormDataItemDate;
};

@Component({
  selector: 'lbca-legalboxplus-legal-request-form',
  templateUrl: './legal-request-form.component.html',
  styleUrls: ['../../sub-form/subform.component.scss', '../../claim/claim.component.scss'],
  imports: [
    MessageFeedbackComponent,
    DatePickerComponent,
    SelectTreeComponent,
    InputTextComponent,
    NgTemplateOutlet,
    EntityFieldsComponent,
    GridboxUniqueComponent,
    IconComponent,
  ],
})
export class LegalRequestFormComponent implements OnInit {
  @Input() taskId;
  @Input() userId;
  @Input() processId;
  @Input() simple;
  @Input('payFields') set extraPayFields(value) {
    this.extraFields = value ?? {};
  }

  @Input() set initialValues(values) {
    this.formData = mapObjIndexedRamda((val, key, obj) => ({ value: val, error: [] }))(
      values
    ) as FormDataLegalRequest;
  }

  @Output('closeModalOutput') closeModalEmmitter = new EventEmitter();
  public extraFields;
  public loadingSubmit = false;
  public flowId!: string;

  public currentStepIndex = 0;

  public config: any;

  public generateFieldsConfig: any = (flowId: string) => ({
    typeId: {
      size: 7,
      label: 'Selecione o tipo de pedido:',
      entityKey: 'typeId',
      type: 'SELECT_TREE',
      bibEntity: {
        context: flowId,
        entityUrl: '/legal-request/drop-data',
        tableName: 'legal-request-type',
      },
      breadcrumbEntity: {
        context: flowId,
        entityUrl: '/legal-request/drop-data/parents',
        tableName: 'legal-request-type',
      },
      required: true,
    },
    dateReference: {
      entityKey: 'dateReference',
      size: 3,
      disabled: true,
      label: 'Data de referência',
      rules: ['du<d'],
      type: 'CALENDAR',
      required: true,
      editable: false,
    },
    primaryValue: {
      size: 3,
      entityKey: 'primaryValue',
      disabled: false,
      label: 'Valor Inicial',
      type: 'TEXT',
      mask: 'CURRENCY_BR',
      required: true,
      editable: false,
    },
    emailList: {
      disabled: false,
      entityKey: 'emailList',
      helperText: '',
      configuration: {
        primary: [
          {
            disabled: false,
            entityKey: 'email',
            helperText: '',
            label: 'E-mail',
            required: true,
            size: 4,
            type: 'TEXT',
            mask: 'EMAIL',
          },
        ],
        secondary: [],
      },
      disable: false,
      label: 'E-mails',
      size: 7,
      type: 'GRIDBOX_UNIQUE',
    },
    ipList: {
      disabled: false,
      entityKey: 'ipList',
      helperText: '',
      configuration: {
        primary: [
          {
            dependency: {
              conditions: [
                {
                  op: 'equal',
                  value: '4',
                  overwrite: {
                    ip: {
                      mask: 'IP',
                      clearValue: true,
                    },
                  },
                },
                {
                  op: 'equal',
                  value: '6',
                  overwrite: {
                    ip: {
                      mask: 'IPV6',
                      clearValue: true,
                    },
                  },
                },
              ],
            },
            auxEntity: {
              listOptions: [
                {
                  value: '4',
                  label: 'IPV4',
                },
                {
                  value: '6',
                  label: 'IPV6',
                },
              ],
            },
            defaultValue: '4',
            disabled: false,
            entityKey: 'ipType',
            helperText: '',
            label: 'Tipo de IP',
            required: false,
            size: 3,
            type: 'SELECT_ONE',
          },
          {
            disabled: false,
            entityKey: 'ip',
            helperText: '',
            label: 'IP',
            required: false,
            size: 4,
            type: 'TEXT',
            mask: 'IP',
          },
        ],
        secondary: [],
      },
      disable: false,
      label: "IP's",
      size: 7,
      type: 'GRIDBOX_UNIQUE',
    },
    urlList: {
      disabled: false,
      entityKey: 'urlList',
      helperText: '',
      configuration: {
        primary: [
          {
            disabled: false,
            entityKey: 'url',
            helperText: '',
            label: 'URL',
            required: true,
            size: 4,
            type: 'TEXT',
          },
        ],
        secondary: [],
      },
      disable: false,
      label: 'URLs',
      size: 7,
      type: 'GRIDBOX_UNIQUE',
    },
    imeiList: {
      disabled: false,
      entityKey: 'imeiList',
      helperText: '',
      configuration: {
        primary: [
          {
            disabled: false,
            entityKey: 'imei',
            helperText: '',
            label: 'IMEI',
            required: false,
            size: 4,
            type: 'TEXT',
            mask: 'ONLY_NUMBERS',
          },
        ],
        secondary: [],
      },
      disable: false,
      label: 'IMEIs',
      size: 7,
      type: 'GRIDBOX_UNIQUE',
    },
    accountIdList: {
      disabled: false,
      entityKey: 'accountIdList',
      helperText: '',
      configuration: {
        primary: [
          {
            disabled: false,
            entityKey: 'accountId',
            helperText: '',
            label: 'ID conta ADS/Workspace',
            required: false,
            size: 4,
            type: 'TEXT',
          },
        ],
        secondary: [],
      },
      disable: false,
      label: 'IDs',
      size: 7,
      type: 'GRIDBOX_UNIQUE',
    },
  });

  private _formData: FormDataLegalRequest = JSON.parse(JSON.stringify(initalFormData));

  public get formData(): FormDataLegalRequest {
    return this._formData;
  }

  public set formData(value: FormDataLegalRequest) {
    if (this._formData.typeId.value !== value.typeId.value)
      this.getLegalRequestTypeById(value.typeId.value);

    if (this._formData.hasInterest.value !== value.hasInterest.value)
      this.formControl = assocPathRamda(
        ['hasInterest', 'visible'],
        value.hasInterest.value,
        this.formControl
      );

    if (this._formData.hasPenalty.value !== value.hasPenalty.value)
      this.formControl = assocPathRamda(
        ['hasPenalty', 'visible'],
        value.hasPenalty.value,
        this.formControl
      );

    if (this._formData.typeExchangeRate.value !== value.typeExchangeRate.value) {
      if (value.typeExchangeRate.value === 'noApply') {
        this.formControl = assocPathRamda(['dolarQuotation', 'visible'], false, this.formControl);
        this.formControl = assocPathRamda(['primaryValueUS', 'visible'], false, this.formControl);
        this.formControl = assocPathRamda(['primaryValue', 'disabled'], false, this.formControl);
      } else {
        this.formControl = assocPathRamda(['dolarQuotation', 'visible'], true, this.formControl);
        this.formControl = assocPathRamda(['primaryValueUS', 'visible'], true, this.formControl);
        this.formControl = assocPathRamda(['primaryValue', 'disabled'], true, this.formControl);
      }
    }

    if (this._formData.interestType.value !== value.interestType.value) {
      this.formControl = assocPathRamda(['interestPercents', 'visible'], true, this.formControl);
      if (value.interestType.value === 'convencional') {
        this.formControl = assocPathRamda(
          ['interestPercents', 'disabled'],
          false,
          this.formControl
        );
      }
      if (value.interestType.value === 'legal') {
        this.formControl = assocPathRamda(['interestPercents', 'disabled'], true, this.formControl);
      }
    }

    this._formData = value;
  }

  public formControl = initalFormControl;

  public cardInfo: any;
  @Input() set cardData(data: any) {
    this.cardInfo = data;

    this.flowId = data.flowId;

    this.config = this.generateFieldsConfig(data.flowId);
  }

  public totalValue = {
    loading: false,
    value: '...',
  };

  public totalValueCorrectBalance = {
    loading: false,
    value: '...',
  };

  public totalRiskCalculate = {
    loading: false,
    value: '...',
  };

  constructor(
    public messageFeedbackService: MessageFeedbackService,
    public legalRequestService: LegalRequestService
  ) {}

  private init = false;
  ngOnInit() {
    this.init = true;
    this.getLegalRequestTypeById(this._formData.typeId.value);
  }

  public formSteps = [
    {
      stepName: 'essentialFields',
      isTouched: true,
      hasError: false,
      fields: ['typeId', 'dateReference'],
    },
  ];

  public changeValue = (
    value: string | boolean | number,
    path: string[],
    cb?: () => void
  ): void => {
    this.formData = assocPathRamda(path, { value, error: [] }, this.formData);

    if (equalsRamda(path, ['interestType'])) {
      if (value === 'convencional') {
        this.formData = assocPathRamda(
          ['interestPercents'],
          { value: '0.00', error: [] },
          this.formData
        );
      }
      if (value === 'legal') {
        this.formData = assocPathRamda(
          ['interestPercents'],
          { value: '0.10', error: [] },
          this.formData
        );
      }
    }

    if (equalsRamda(path, ['primaryValueUS']) || equalsRamda(path, ['dolarQuotation'])) {
      const getValueNumber = (prop) => pipeRamda(pathRamda([prop, 'value']), Number);

      this.formData = assocPathRamda(
        ['primaryValue'],
        {
          value: pipeRamda(
            (obj) =>
              multiplyRamda(
                getValueNumber('primaryValueUS')(obj),
                getValueNumber('dolarQuotation')(obj)
              ),
            (i: number) => i.toFixed(2)
          )(this.formData),
          error: [],
        },
        this.formData
      );
    }

    if (cb) {
      cb();
    }
  };

  public actionBackRegister($event) {
    if (this.currentStepIndex === 0) {
      this.closeModal();
    } else {
      this.goToBackStep();
    }
  }

  public closeModal() {
    this.clearForm();
    this.closeModalEmmitter.emit(true);
  }

  public clearForm() {
    this.formControl = initalFormControl;
    this._formData = JSON.parse(JSON.stringify(initalFormData));
  }

  public goToBackStep() {
    this.currentStepIndex -= 1;
  }

  public getLegalRequestTypeById($event): void {
    if (!this.init) return;

    if (!$event) {
      this.formSteps = [
        {
          stepName: 'essentialFields',
          isTouched: true,
          hasError: false,
          fields: ['typeId', 'dateReference'],
        },
      ];

      return;
    }

    this.legalRequestService.getLegalRequestTypeById($event, this.flowId).subscribe(
      (response, ...rest) => {
        const {
          hasPay = false,
          hasEmailList = false,
          hasIPList = false,
          hasURLList = false,
          hasIMEIList = false,
          hasAccountIdList = false,
        } = response;

        this.formSteps = [
          {
            stepName: 'essentialFields',
            isTouched: true,
            hasError: false,
            fields: ['typeId', 'dateReference'],
          },
        ];

        if (hasPay) {
          if (this.simple) {
            this.formSteps.push({
              stepName: 'payFields',
              isTouched: false,
              hasError: false,
              fields: ['primaryValue'],
            });
          } else {
            const defaultFields = [
              'typeExchangeRate',
              'dolarQuotation',
              'primaryValueUS',
              'primaryValue',
              'endValue',
              'primaryIndexId',
              'hasInterest',
              'interestType',
              'interestDateReference',
              'interestPercents',
              'hasPenalty',
              'penaltyPercents',
            ];
            this.formSteps.push({
              stepName: 'payFields',
              isTouched: false,
              hasError: false,
              fields: defaultFields,
            });
          }
        }
        if (hasEmailList)
          this.formSteps.push({
            stepName: 'emailFields',
            isTouched: false,
            hasError: false,
            fields: [],
          });
        if (hasIPList)
          this.formSteps.push({
            stepName: 'ipFields',
            isTouched: false,
            hasError: false,
            fields: [],
          });
        if (hasURLList)
          this.formSteps.push({
            stepName: 'urlFields',
            isTouched: false,
            hasError: false,
            fields: [],
          });
        if (hasIMEIList)
          this.formSteps.push({
            stepName: 'imeiFields',
            isTouched: false,
            hasError: false,
            fields: [],
          });
        if (hasAccountIdList)
          this.formSteps.push({
            stepName: 'accountIdFields',
            isTouched: false,
            hasError: false,
            fields: [],
          });
      },
      (error) => {
        console.error(error);
      }
    );
  }

  public validateStep = (stepName: string) => {
    const step = this.formSteps.find((item) => item.stepName === stepName);

    if (step) {
      this.validateFields(step.fields);
      step.hasError = this.verifyHasError(step.fields);
      step.isTouched = true;
    }
  };

  public verifyHasError = (fields: string[]): boolean => {
    let hasError = false;

    for (const field of fields) {
      const formDataField = this.formData[field];

      if (formDataField?.error?.length > 0) {
        hasError = true;
      }
    }

    return hasError;
  };

  public validateFields = (fields: string[]) => {
    for (const field of fields) {
      const formDataField = this.formData[field];
      const formControlField = this.formControl[field];
      const fieldsConfig = this.config[field];

      if ((formControlField?.visible ?? true) && fieldsConfig?.required && !formDataField?.value) {
        formDataField.error = ['Campo obrigatório'];
      }
    }
  };

  public goToNextStep(step) {
    // set error when has error
    this.validateStep(step.stepName);

    // verify if has error
    if (step.hasError) return;

    this.currentStepIndex += 1;

    this.formSteps[this.currentStepIndex].isTouched = true;
  }

  private defautlFeedbackServerError(error): void {
    this.messageFeedbackService.setFeedback(
      'Ops... ocorreu um erro',
      error?.mesage ?? 'Ocorreu um erro ao processar as informações',
      'emoji--expressionless',
      'danger'
    );
  }

  public submitLegalRequestForm(step) {
    this.loadingSubmit = true;

    // set error when has error
    this.validateStep(step.stepName);

    // verify if has error
    if (step.hasError) {
      this.loadingSubmit = false;
      return;
    }

    const taskId = this.taskId;
    const userId = this.userId;
    const processId = this.processId;

    const params: any = {
      taskId,
      processId,
      userId,
    };

    const body: { [key: string]: any } = {
      ...mapObjIndexedRamda((val, key, obj) => val?.['value'])(this.formData),
      context: 'legalRequest',
    };

    if (body?.['id']) {
      params.id = body['id'];

      this.legalRequestService.editClaim(body, params).subscribe(
        (resp: any) => {
          this.loadingSubmit = false;
          if (resp.errors) {
            this.defautlFeedbackServerError(resp.errors);
            return;
          }

          this.closeModal();
        },
        (err: any) => {
          this.loadingSubmit = false;
          this.defautlFeedbackServerError(err);
        }
      );
    } else {
      this.legalRequestService.createLegalRequest(body, params).subscribe(
        (response: any) => {
          this.loadingSubmit = false;
          if (response.errors || response.message) {
            this.defautlFeedbackServerError(response.errors);
          } else {
            // this.showPopup();
            this.closeModal();
          }
        },
        (err: any) => {
          this.loadingSubmit = false;
          this.defautlFeedbackServerError(err);
        }
      );
    }
  }

  public toogleShowSubForm = (path: string[]) => {};

  public toogle(path: string[]) {
    const pathValue = pathRamda(path, this.formControl) as any;

    this.formControl = assocPathRamda(
      path,
      { ...pathValue, visible: !pathValue?.['visible'], disabled: !pathValue?.['disabled'] },
      this.formControl
    );
    this.changeValue(!pathValue?.['visible'], path);
    this.callCalc();
  }

  public callCalc = () => {
    this.totalValue.loading = true;
    this.totalValueCorrectBalance.loading = true;
    this.totalRiskCalculate.loading = true;

    const values = {
      ...mapObjIndexedRamda((val, key, obj) => val?.['value'])(this.formData),
      hasInterest: this.formControl.hasInterest.visible,
      hasPenalty: this.formControl.hasPenalty.visible,
    };

    this.legalRequestService
      .calculation(values)
      .then((respPromise: any) => {
        this.totalValue.value = respPromise.valTotalInicial;
        this.totalValueCorrectBalance.value = respPromise.valTotalAtualizado;
        this.totalRiskCalculate.value = respPromise.valTotalRisco;
      })
      .finally(() => {
        this.totalValue.loading = false;
        this.totalValueCorrectBalance.loading = false;
        this.totalRiskCalculate.loading = false;
      });
  };
}
